import { Typography } from '@euler/app/components/typography';
import { formatDateTime } from '@euler/utils/formatters';
import { ChevronLeft } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';
import { useBoardUnit } from '../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../workshopBoardColors';
import { WorkshopBoardMode } from '../workshopBoardMode';
import { ModeSwitch } from './ModeSwitch';

const kWeekdays = ['日', '一', '二', '三', '四', '五', '六'];

/** The store, which board shows, and the time. */
export const BoardHeader = memo(
  ({
    storeName,
    now,
    mode,
    onModeChange,
    onBack,
  }: {
    storeName: string | undefined;
    now: Date;
    mode: WorkshopBoardMode;
    onModeChange: (mode: WorkshopBoardMode) => void;
    onBack: () => void;
  }) => {
    const u = useBoardUnit();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: u(16),
        }}
      >
        <Pressable
          accessibilityRole="button"
          accessibilityLabel="返回"
          hitSlop={u(16)}
          onPress={onBack}
        >
          <ChevronLeft size={u(40)} color={colors.faint} />
        </Pressable>
        <View style={{ flex: 1 }}>
          <Typography.Text size={u(40)} bold color={colors.foreground}>
            车间看板
          </Typography.Text>
          {storeName ? (
            <Typography.Text size={u(22)} color={colors.muted}>
              {storeName}
            </Typography.Text>
          ) : null}
        </View>
        <ModeSwitch mode={mode} onChange={onModeChange} />
        <View style={{ alignItems: 'flex-end', marginLeft: u(16) }}>
          <Typography.Text
            size={u(48)}
            bold
            color={colors.foreground}
            style={{ fontVariant: ['tabular-nums'] }}
          >
            {formatDateTime(now, 'HH:mm')}
          </Typography.Text>
          <Typography.Text size={u(20)} color={colors.muted}>
            {formatDateTime(now, 'yyyy年M月d日')} 星期{kWeekdays[now.getDay()]}
          </Typography.Text>
        </View>
      </View>
    );
  },
);
